import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { formatTimestamp } from "../../../utils/utils";
import styles from "../../network_map/network_map.module.css";

export default function RoadChanges({ changes, error, onGo }) {
  const { t } = useTranslation();
  const [tab, setTab] = useState("worsened");
  if (error) return <div className={styles.empty}>{t("roadmap.changes.loadError")}</div>;
  if (!changes) return <div className={styles.empty}>…</div>;
  const items = changes[tab] || [];
  const w = changes.windows || {};
  return (
    <div>
      <div className={styles.timelineHeader}>
        <div className={styles.chips}>
          <button type="button" className={`${styles.chip} ${tab === "worsened" ? styles.chipActive : ""}`} onClick={() => setTab("worsened")}>
            ▼ {t("roadmap.changes.worsened")} ({(changes.worsened || []).length})
          </button>
          <button type="button" className={`${styles.chip} ${tab === "improved" ? styles.chipActive : ""}`} onClick={() => setTab("improved")}>
            ▲ {t("roadmap.changes.improved")} ({(changes.improved || []).length})
          </button>
        </div>
        <div className={styles.timelineMeta}>{t("roadmap.changes.windows", { recent: w.recent_days, baseline: w.baseline_days })}</div>
      </div>
      {items.length === 0 ? (
        <div className={styles.empty}>{t(`roadmap.changes.empty_${tab}`)}</div>
      ) : (
        <div className={styles.changeList}>
          {items.map((item) => (
            <div key={item.key} className={styles.changeRow}>
              <div className={`${styles.delta} ${item.delta < 0 ? styles.deltaDown : styles.deltaUp}`}>{item.delta > 0 ? "+" : ""}{Math.round(item.delta)}</div>
              <div className={styles.changeMain}>
                <div className={styles.changeScores}>{t("roadmap.changes.scoreLine", { before: Math.round(item.score_before), after: Math.round(item.score_after) })}</div>
                <div className={styles.changeMeta}>
                  {t("roadmap.changes.rmsLine", { before: item.rms_before, after: item.rms_after })} · {t("roadmap.changes.impactsLine", { before: item.impacts_before, after: item.impacts_after })} · {t("roadmap.changes.last")}: {formatTimestamp(item.last_seen)}
                </div>
              </div>
              <button type="button" className={styles.smallButton} onClick={() => onGo(item)}>{t("roadmap.changes.go")}</button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
